// @flow

import React, { type Node } from 'react';
import { InstructionsText } from '../commons/instructions-text';

export function ArgentineCashInstructions(): Node {
  return (
    <InstructionsText>
      Usa esto código para realizar tu pago
    </InstructionsText>
  );
}
